import { useGetRouteToIssuerPage } from '../../../../app/get-route-to-page';
import { Page } from '../../../../app/page-url-path';
import { usePostLoginRedirectDestination } from '../../../../hooks/usePostLoginRedirectDestination';
import type { LoginMethod } from '../../../../selectors/interfaces';
import { setSearchParamOnUrl } from '../../../../utils/url-search-params/set-url-search-param-on-path';
import UrlSearchParamKey from '../../../../utils/url-search-params/url-search-params';

export const useLoginNavigation = () => {
  const { getPostLoginRedirectDestination } = usePostLoginRedirectDestination();
  const routeToInternalLoginPage = useGetRouteToIssuerPage(Page.LOGIN_PAGE);

  const getLinkToInternalLoginPage = (internalLoginMethod?: LoginMethod) => {
    const destinationUrl = new URL(
      routeToInternalLoginPage,
      window.location.origin,
    );
    if (internalLoginMethod) {
      setSearchParamOnUrl(
        destinationUrl,
        UrlSearchParamKey.LOGIN_METHOD,
        internalLoginMethod,
      );
    }
    const postLoginRedirectDestination = getPostLoginRedirectDestination(
      false,
      false,
    );
    setSearchParamOnUrl(
      destinationUrl,
      UrlSearchParamKey.REDIRECT_TO,
      postLoginRedirectDestination,
    );
    return destinationUrl;
  };

  const getLinkToInternalMainLoginPage = () => getLinkToInternalLoginPage();

  const getLinkToInternalLoginMethod = (internalLoginMethod: LoginMethod) =>
    getLinkToInternalLoginPage(internalLoginMethod);

  return { getLinkToInternalMainLoginPage, getLinkToInternalLoginMethod };
};
